// 3rd party imports
import * as React from 'react';

// shared-ui
import { LocalizedText } from '@shared-ui/localization-context';

// ui
import { UitkPrimaryButton, UitkButtonSize } from 'uitk-react-button';

// util
import { getUserAnalyticsMicroMessage } from '../../util/analytics';

import { useStores, useLocaleParam } from '../../hooks';
import { observer } from 'mobx-react';

// TODO: remove after redesign launched
interface AffiliateCTAProps {
  size?: UitkButtonSize.SMALL | UitkButtonSize.MEDIUM | UitkButtonSize.LARGE;
  analyticsConfig?;
}

export const AffiliateCTA: React.FunctionComponent<AffiliateCTAProps> = observer(({ size, analyticsConfig }) => {
  const { analytics, userAuth, pzStore } = useStores();

  const { signupLink } = useLocaleParam();

  const referrerId = 'affhub_header_join_now.selected';
  const linkName = 'AffHub Header Join Now Selected';
  const analyticsSignupSelected = {
    id: referrerId,
    callback: () => {
      if (analytics && typeof analytics.trackEvent === 'function') {
        analytics.trackEvent(referrerId, linkName, null, null, true, [
          getUserAnalyticsMicroMessage(userAuth?.currentUserDetails, pzStore?.pzPublisher),
        ]);
      }
    },
  };

  return (
    <>
      <UitkPrimaryButton
        analytics={analyticsConfig ? analyticsConfig : analyticsSignupSelected}
        tag={'a'}
        href={signupLink}
        data-cy="sign-up-link"
        size={size ? size : UitkButtonSize.MEDIUM}
      >
        <LocalizedText message="common.join_now" />
      </UitkPrimaryButton>
    </>
  );
});
